import { usePageContent } from "@/hooks/usePageContent";
import SafeHtml from "@/components/base/SafeHtml";

export default function IntroSection() {
  const { getContent } = usePageContent('homepage');
  const heading = getContent('home-intro-heading') || 'Unlock the Hidden Gold in Your Dirt';
  const body = getContent('home-intro-body');

  return (
    <section className="py-20 bg-background-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <span className="inline-block text-sm text-primary-500 font-medium uppercase tracking-wider">
            Welcome to CashMyProperty.ai
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground-950">
            {heading}
          </h2>
          {body && body.includes('<p>') ? (
            <SafeHtml
              html={body}
              className="text-foreground-600 text-lg leading-relaxed space-y-4"
            />
          ) : (
            <>
              <p className="text-foreground-600 text-lg leading-relaxed">
                Millions of acres of land across India sit idle because owners lack the capital
                or expertise to develop them. CashMyProperty.ai is a PropTech venture designed to
                assist landowners in monetizing idle, non-performing, or under-utilized real estate
                assets — without selling.
              </p>
              <p className="text-foreground-600 leading-relaxed">
                Unlike traditional brokerage firms that simply aim to sell, our primary objective is to
                retain asset ownership while generating cash flow, or to maximize sale value through
                strategic development. By leveraging Artificial Intelligence for{" "}
                <strong className="text-foreground-950">Highest and Best Use</strong> analysis,
                we connect landowners with the right monetization models — ranging from Joint
                Development Agreements and long-term commercial leasing to franchise partnerships
                and retail outlet placements.
              </p>
              <p className="text-foreground-600 leading-relaxed">
                Whether you&apos;re an <strong className="text-foreground-950">NRI</strong> managing property
                remotely, a <strong className="text-foreground-950">family</strong> sitting on ancestral
                land, or a <strong className="text-foreground-950">retired senior</strong> who is asset-rich
                but cash-poor — our AI feasibility engine calculates the Highest &amp; Best Use of your
                property and delivers a comprehensive monetization roadmap within 48 hours.
              </p>
            </>
          )}
          <div className="pt-4">
            <button
              onClick={() => {
                const el = document.querySelector("#contact");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Get Your Feasible AI Report
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}